var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('UiCard',[_c('UiNavigationBar',{attrs:{"bleed":"","responsive":"","title":_vm.$t('general.payment-history')},on:{"back":function($event){return _vm.$router.go(-1)}}}),_c('div',[_c('UiPaymentMethods')],1),_c('div',{staticClass:"tw-mt-6"},[_c('UiPaymentsHistory')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }